import React, { useContext, useEffect, useState } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import { State } from "../../store/state";
import {
  Grid,
  IconButton,
  Typography,
  Paper,
  Slider,
  TextField,
  Box,
  InputAdornment,
  Divider,
  Link,
} from "@material-ui/core";
import { Info as InfoIcon } from "@material-ui/icons";
import * as consts from "../../consts";
import { setSupportPercent, setSupportTotal } from "../../store/actions";

export default function TotalQuote({ quote }) {
  const useStyles = makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(2),
    },
    iconButton: {
      "&:focus": { color: "inherit" },
      "&:hover": { color: "inherit" },
    },
    input: {
      "& input": {
        height: "96%",
        padding: "18.5px 14px",
        border: "0",
        background: "none",
      },
    },
    selected: {
      height: "56px",
      width: "96%",
      textAlign: "center",
      cursor: "pointer",
      border: "1px solid #f26820",
      borderRadius: "16px",
      paddingTop: "6px",
    },
    unselected: {
      height: "56px",
      width: "100%",
      textAlign: "center",
      cursor: "pointer",
      border: "1px solid #cccccc",
      borderRadius: "16px",
      paddingTop: "6px",
    },
  }));
  const classes = useStyles();
  const { state, dispatch } = useContext(State);
  const [error, setError] = useState(null);
  const [expandProductionFeesInfo, setExpandProductionFeesInfo] =
    useState(false);
  const [expandShippingFeesInfo, setExpandShippingFeesInfo] = useState(false);
  const [expandCreditCardFeesInfo, setExpandCreditCardFeesInfo] =
    useState(false);
  const [totals, setTotals] = useState({
    cardCount: 0,
    cardTotal: 0,
    productionTotal: 0,
    shippingTotal: 0,
    orderAdjustments: 0,
    creditCardFee: 0,
    total: 0,
  });

  const [tempSupportAmount, setTempSupportAmount] = useState(null);

  useEffect(() => {
    let cardCount = 0;
    let cardTotal = 0;
    let productionTotal = 0;
    let shippingTotal = 0;
    let orderAdjustments = 0;
    state.orderAdjustments.map((orderAdjustment) => {
      if (!isNaN(orderAdjustment.amount)) {
        orderAdjustments += parseFloat(orderAdjustment.amount);
      }
    });
    let sendToMeShippingAdded = false;

    quote.map((cartItem, cartItemIndex) => {
      cardCount += cartItem.cardDetails.length;
      switch (cartItem.cardType) {
        case consts.CARD_TYPE_PLASTIC:
          if (
            cartItem.mailOption == consts.PLASTIC_TYPE_ME ||
            cartItem.mailOption == consts.PLASTIC_TYPE_NO_CARRIER
          ) {
            cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
              cardTotal += cartItem.cardValue;
              if (cardDetail.cardFee) {
                productionTotal += cardDetail.cardFee.productionFee;
                if (!sendToMeShippingAdded && cardDetailIndex == 0) {
                  sendToMeShippingAdded = true;
                  shippingTotal += cardDetail.cardFee.shippingHandling;
                }
              }
            });
          } else {
            cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
              cardTotal += cartItem.cardValue;
              if (cardDetail.cardFee) {
                productionTotal += cardDetail.cardFee.productionFee;
                shippingTotal += cardDetail.cardFee.shippingHandling;
              }
            });
          }
          break;
        case consts.CARD_TYPE_EMAIL:
          cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
            }
          });
          break;
        case consts.CARD_TYPE_PRINTER:
          cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
            }
          });
          break;
      }
    });

    let creditCardFee =
      (cardTotal + productionTotal + shippingTotal + orderAdjustments) * 0.03;

    let total =
      cardTotal +
      productionTotal +
      shippingTotal +
      orderAdjustments +
      creditCardFee;

    setTotals({
      cardCount: cardCount,
      cardTotal: cardTotal,
      productionTotal: productionTotal,
      shippingTotal: shippingTotal,
      orderAdjustments: orderAdjustments,
      creditCardFee: creditCardFee,
      total: total,
    });
    if (state.supportPercent) {
      let supportTotal = total * (state.supportPercent / 100);
      setSupportPercent(state.supportPercent, supportTotal, dispatch);
    }
  }, [quote]);

  const convertToMoney = (value) => {
    let decPlaces = 2;
    let decSep = ".";
    let thouSep = ",";
    var sign = value < 0 ? "-$" : "$";
    var i = String(
      parseInt((value = Math.abs(Number(value) || 0).toFixed(decPlaces)))
    );
    var j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces
        ? decSep +
          Math.abs(value - i)
            .toFixed(decPlaces)
            .slice(2)
        : "")
    );
  };

  const renderTotal = () => {
    return (
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                color="primary"
                className={classes.header}
              >
                Cart Summary (
                {totals.cardCount > 0
                  ? totals.cardCount > 1
                    ? totals.cardCount + " items"
                    : "1 item"
                  : "No items"}
                )
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">Gift Card Total</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(totals.cardTotal)}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">
                Production Costs
                <IconButton
                  className={classes.iconButton}
                  size="small"
                  aria-label="Production fee information"
                  color="inherit"
                  onClick={(event) => {
                    setExpandProductionFeesInfo(!expandProductionFeesInfo);
                  }}
                >
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(totals.productionTotal)}
              </Typography>
            </Grid>
            {expandProductionFeesInfo ? (
              <Grid item xs={12}>
                <Typography variant="caption">
                  For our biodegradable plastic charity gift cards, you pay the
                  card face value plus $3.29 which helps cover the cost of the
                  plastic gift card, greeting card, envelope, and handling.
                </Typography>
              </Grid>
            ) : null}
            <Grid item xs={8}>
              <Typography variant="body1">
                Shipping{" "}
                <IconButton
                  className={classes.iconButton}
                  size="small"
                  aria-label="Shipping fee information"
                  color="inherit"
                  onClick={(event) => {
                    setExpandShippingFeesInfo(!expandShippingFeesInfo);
                  }}
                >
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(totals.shippingTotal)}
              </Typography>
            </Grid>
            {expandShippingFeesInfo ? (
              <Grid item xs={12}>
                <Typography variant="caption">
                  We ship orders of 200 cards or less typically within 2
                  business days. USPS First Class 5-7 Day shipping is free for
                  1-8 cards, and 9 or more “Mail to Me” cards include a free
                  upgrade to USPS Priority 2-4 Day. For help shipping large
                  orders please contact sales@tisbest.org.
                </Typography>
              </Grid>
            ) : null}
            <Grid item xs={8}>
              <Typography variant="body1">
                Credit Card Processor 3%{" "}
                <IconButton
                  className={classes.iconButton}
                  size="small"
                  aria-label="Credit Card Processor fee information"
                  color="inherit"
                  onClick={(event) => {
                    setExpandCreditCardFeesInfo(!expandCreditCardFeesInfo);
                  }}
                >
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(totals.creditCardFee)}
              </Typography>
            </Grid>
            {expandCreditCardFeesInfo ? (
              <Grid item xs={12}>
                <Typography variant="caption">
                  This helps cover most of the fees we're charged to process
                  credit card payments. For large orders please contact{" "}
                  <Link href="mailto:sales@tisbest.org">sales@tisbest.org</Link>{" "}
                  for other invoice options.
                </Typography>
              </Grid>
            ) : null}
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">Support TisBest's Mission</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(state.supportTotal)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid
                item
                container
                xs={12}
                spacing={2}
                style={{ margin: "auto" }}
              >
                <Grid item container xs={12} sm={8} spacing={1}>
                  <Grid
                    item
                    xs={4}
                    onClick={() => {
                      setTempSupportAmount(null);
                      let supportTotal = totals.total * 0.05;
                      setSupportPercent(5, supportTotal, dispatch);
                    }}
                  >
                    <Box
                      className={
                        state.supportPercent == 5
                          ? classes.selected
                          : classes.unselected
                      }
                    >
                      <div>5%</div>
                      <div>
                        {convertToMoney(
                          Math.round(parseFloat(totals.total * 0.05) * 100) /
                            100
                        )}
                      </div>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    onClick={() => {
                      setTempSupportAmount(null);
                      let supportTotal = totals.total * 0.1;
                      setSupportPercent(10, supportTotal, dispatch);
                    }}
                  >
                    <Box
                      className={
                        state.supportPercent == 10
                          ? classes.selected
                          : classes.unselected
                      }
                    >
                      <div>10%</div>
                      <div>
                        {convertToMoney(
                          Math.round(parseFloat(totals.total * 0.1) * 100) / 100
                        )}
                      </div>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    onClick={() => {
                      setTempSupportAmount(null);
                      let supportTotal = totals.total * 0.15;
                      setSupportPercent(15, supportTotal, dispatch);
                    }}
                  >
                    <Box
                      className={
                        state.supportPercent == 15
                          ? classes.selected
                          : classes.unselected
                      }
                    >
                      <div>15%</div>
                      <div>
                        {convertToMoney(
                          Math.round(parseFloat(totals.total * 0.15) * 100) /
                            100
                        )}
                      </div>
                    </Box>
                  </Grid>
                </Grid>
                <Grid item container xs={12} sm={4} spacing={1}>
                  <Grid item xs={12}>
                    <TextField
                      className={classes.input}
                      fullWidth={true}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      label="Custom Amount"
                      value={
                        tempSupportAmount
                          ? tempSupportAmount
                          : convertToMoney(state.supportTotal).replace(
                              /[^0-9.-]+/g,
                              ""
                            )
                      }
                      onChange={(event) => {
                        if (
                          parseFloat(event.target.value) ||
                          parseFloat(event.target.value) == 0
                        ) {
                          setTempSupportAmount(event.target.value);
                        }
                      }}
                      onBlur={(event) => {
                        if (parseFloat(tempSupportAmount)) {
                          setSupportTotal(tempSupportAmount, dispatch);
                        } else {
                          setSupportTotal(0, dispatch);
                        }
                        setTempSupportAmount(null);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                Your optional, tax-deductible donation helps our charity cover
                costs and increase giving to other charities across the country.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            {state.orderAdjustments.map((orderAdjustment) => {
              return (
                <React.Fragment>
                  <Grid item xs={8}>
                    <Typography variant="body1">
                      {orderAdjustment.description}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body1" align="right">
                      {convertToMoney(orderAdjustment.amount)}
                    </Typography>
                  </Grid>
                </React.Fragment>
              );
            })}
            <Grid item xs={8}>
              <Typography variant="body1">Total</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" align="right">
                {convertToMoney(totals.total + state.supportTotal)}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );
  };

  return <React.Fragment>{renderTotal()}</React.Fragment>;
}
